import React from 'react';
import moment from 'moment';
import { Badge } from 'antd';
import { TextIcon } from '../../../Icons/AryaIcons';
import './SMSNotification.scss';
import { handleSmsAndChatNotificationClick } from '../../../Utils/NotificationUtils';

function getIcon() {
  return (
    <TextIcon
      style={{ fontSize: 20, padding: 10, color: '#48E29A', backgroundColor: '#DAF0E5', borderRadius: '50%' }}
    />
  );
}

function getSenderName(senderName, currentUserId, senderId, IsByBot) {
  let name;

  if (IsByBot) {
    name = 'Text Agent';
  } else if (currentUserId === senderId) {
    name = 'You';
  } else {
    const firstName = senderName && senderName.split(' ')[0];
    name = firstName;
  }

  return name;
}

function SMSNotification(props) {
  const { notification, onClick, currentUser, jobDetails, setCurrentMessagePopupInfos, ats } = props;
  const { UnreadCount } = notification;
  const { CreatedTime, SenderName, Message, PersonName, SenderId, IsByBot, IsByPerson } = notification.Payload;
  return (
    <div
      className="connect-notification"
      onClick={() => {
        handleSmsAndChatNotificationClick({ notification, setCurrentMessagePopupInfos, onClick });
      }}
      role="presentation"
    >
      <div className="icon">{getIcon()}</div>
      <div className="content">
        <div className="sender-name">{PersonName}</div>
        <div>
          {jobDetails.JobTitle} {ats ? jobDetails.JobCode : jobDetails.JobId}
        </div>
        <Badge dot={UnreadCount > 0}>
          <div className="message">
            <span>{!IsByPerson ? `${getSenderName(SenderName, currentUser.sub, SenderId, IsByBot)}: ` : ''}</span>
            <span>{Message}</span>
          </div>
        </Badge>
        <div className="since">{moment.utc(CreatedTime).local().fromNow()}</div>
      </div>
    </div>
  );
}

export default SMSNotification;
